import block from './block.json';

export const cardFeatureThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [0, 0],
			right: [0, 0],
			bottom: [1, 1],
			left: [0, 0],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	minWidth: '250px',
	maxWidth: '300px',
	padding: {
		top: [10, 20],
		right: [10, 20],
		bottom: [10, 20],
		left: [10, 20],
	},
	text: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardFeatureThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardFeatureThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
